<app-web-loader *ngIf="isLoader"></app-web-loader>

<div class="main-customer-post-div">
    <div class="builderSearchDiv">
        <div class="modal-content">
            <div class="modal-body">
                <div class="search_block"><div class="search_ic"></div>
                <input placeholder="Search Areas" type="text" id="txt-search" class="form-control txt-search"
                    (keyup)="doSearch($event)" autocomplete="off" />
                    <button type="button" class="btn btn_search" (click)="LoadUsersList()">Search</button>
                </div>
                <div style="margin-top: 50px;"></div> <!-- Adjust the margin-top value as needed -->
                <div class="custom_search">
                <div class="custom-control custom-checkbox" *ngFor="let area of arrList">
                    <input type="checkbox" (change)="addPreferredAreas($event, area)" class="custom-control-input"
                        id="area{{area.AreaID}}">
                    <label class="custom-control-label" for="area{{area.AreaID}}">{{ area.AreaName }}</label>
                </div>
            </div>
                <div class="searchbtnDiv" *ngIf="arrList.length > 0">
                    <button type="button" class="btn btn-sm btn-block btn-success"
                        (click)="LoadUsersList()">Search</button>
                </div>
            </div>
        </div>
        <div class="form-control search_result" *ngIf="selectedAreasID.length > 0">
            <div class="selected-location-div">
                <p *ngFor="let selArs of selectedAreasID">
                    {{ selArs.AreaName }}
                    <span (click)="removePreferredAreas(selArs)"></span>
                </p>
            </div>
        </div>
    </div>
<div class="clearfix mrg10B"></div>
<div class="row mrg0A clear">
      <div class="col-md-6" *ngFor="let user of usersList" (click)="gotoUserPostPage(user)">
        <div class="carbon-example flex-wrapper">
            <!-- Adjust your user card layout accordingly -->
           <div class="img_div"> <img [src]="user?.UserProfile" onerror="this.src='assets/images/customer_images.jpg'"
                alt="example design logo">
            </div>
            <div class="inner-wrapper">
                <p style="font-size: 18px; font-weight: bold; margin-bottom: 0;">{{ user.CustomerName }}</p>
                <p style="margin-top: 0; color: #959292;">{{ user.User_Address }}</p>
            </div>
        </div>  
    </div>  

  
</div>
</div>